webpackJsonp([2],{

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(330);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _axios = __webpack_require__(38);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReferenceShort = function (_React$Component) {
    _inherits(ReferenceShort, _React$Component);

    _createClass(ReferenceShort, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var showed = 0;

            if (this.state.refs.length < 1) return null;
            return _react2.default.createElement(
                'div',
                { className: 'contentTextContainer' },
                _react2.default.createElement(
                    'h2',
                    null,
                    'Zku\u0161enosti n\u011Bkter\xFDch na\u0161ich\xA0student\u016F'
                ),
                this.state.refs.map(function (ref, index) {
                    if (showed >= _this2.state.showRefs) return null;

                    var textLength = ref.text.length;
                    var text = ref.text;
                    var showMore = !ref.showed;
                    if (showMore && textLength > 250) {
                        var tmp = document.createElement("DIV");
                        tmp.innerHTML = text;
                        text = tmp.textContent || tmp.innerText || "";
                        text = text.substr(0, 250);
                        text = '<p>' + text + '</p>';
                    } else {
                        showMore = false;
                    }
                    showed++;
                    return _react2.default.createElement(
                        'blockquote',
                        { key: ref.reference_id },
                        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: text } }),
                        ref.from_name.length > 0 && !showMore && _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'b',
                                null,
                                ref.from_name
                            )
                        ),
                        showMore && _react2.default.createElement(
                            'a',
                            { href: '#', className: 'more', onClick: function onClick(e) {
                                    e.preventDefault();_this2.showRef(index);
                                } },
                            'Cel\xE1 recenze'
                        )
                    );
                }),
                this.state.refs.length > this.state.showRefs ? _react2.default.createElement(
                    'a',
                    { href: '#', className: 'btn-more', onClick: this.showMore },
                    'Zobrazit dal\u0161\xED reference'
                ) : _react2.default.createElement(
                    'a',
                    { href: this.state.moreUrl, className: 'btn-more', target: '_blank' },
                    'Zobrazit dal\u0161\xED reference'
                )
            );
        }
    }]);

    function ReferenceShort(props) {
        _classCallCheck(this, ReferenceShort);

        var _this = _possibleConstructorReturn(this, (ReferenceShort.__proto__ || Object.getPrototypeOf(ReferenceShort)).call(this, props));

        _this.showRef = function (index) {
            var refs = [].concat(_toConsumableArray(_this.state.refs));
            refs[index].showed = true;

            _this.setState({ refs: refs });
        };

        _this.showMore = function (e) {
            e.preventDefault();
            _this.setState({ showRefs: _this.state.showRefs + _this.state.moreStep });
        };

        _this.state = {
            refs: [],
            showRefs: 3,
            moreStep: 3,
            moreUrl: ""
        };
        return _this;
    }

    _createClass(ReferenceShort, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            _axios2.default.get("/", { params: { action: "getRefs", pageId: window.pageId, schoolId: window.schoolId ? window.schoolId : null } }).then(function (response) {

                _this3.setState({ refs: response.data.items, moreUrl: response.data.moreUrl });
            }).catch(function (error) {});
        }
    }]);

    return ReferenceShort;
}(_react2.default.Component);

_reactDom2.default.render(_react2.default.createElement(ReferenceShort, null), document.getElementById('reference-short'));

/***/ })

},[824]);


// WEBPACK FOOTER //
// referenceShort.js